import React from "react";
import { Modal } from "antd";
import PieChartView from "./Table";

interface Props {
  open: boolean;
  onClose: () => void;
}

export default function DonutChartDetailsModal({ open, onClose }: Props) {
  return (
    <Modal
      title="Pie Chart Details"
      open={open}
      onCancel={onClose}
      footer={null}
      width={870}
      centered
    >
      <PieChartView />
    </Modal>
  );
}
